import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Row,
  Typography,
  Layout,
  Image,
  Card,
  Spin,
  Input,
  message,
} from "antd";
import { useNavigate, useParams } from "react-router";
import { UPLOADS_URL, MEETING, QUIZ } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import swal from "sweetalert";
import "react-alice-carousel/lib/alice-carousel.css";
import dayjs from "dayjs";
import { BsDot } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";
//icons

function QuizDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [reviews, setReviews] = useState([]);
  const [ratings, setRatings] = useState({});
  const [quiz, setQuiz] = useState({});
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const { Search } = Input;
  const [loading, setLoading] = useState(true);
  const [meetings, setMeetings] = useState([]);
  const [range, setRange] = useState([10, 200]);
  const [review, setReview] = useState({
    averageRating: 0,
    totalReviews: 0,
  });
  const [rates, setRates] = useState({
    hourlyRate: 0,
    tutoringRate: 0,
    meetingingRate: 0,
  });

  const quizAttemted = useMemo(
    () => Boolean(quiz?.quiz?.attempts?.length),
    [quiz]
  );
  

  const item = { rating: 4 };

  useEffect(() => {
    getQuizDetails();
    if (token) {
      getMyMeetings();
    }
  }, []);



  const getMyMeetings = async (pageNumber, keyword, category) => {
    setLoading(true);
    try {
      const response = await Get(MEETING.getMyMeetings, token, {
        limit: "100",
      });
      setLoading(false);

      if (response?.status) {
        setMeetings(response?.data?.meetings.map((item) => item._id));
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const getQuizDetails = async () => {
    try {
      const response = await Get(QUIZ.getQuizById + id, token);
     
      if (response?.status) {
        setQuiz(response?.data);
      } else {
        swal("Error", response?.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

 console.log(quiz?.quiz?.attempts[0]?.status, "quiz attempt status");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{
            fontSize: "30px",
            color: "#333d47",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          {<> Quiz Details</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{
          backgroundColor: "white",
          justifyContent: "center",
          padding: "50px",
        }}
        gutter={20}
      >
        <Col xs={24} md={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "10px",
            }}
          >
            <div style={{ marginBottom: 20, marginLeft: 10 }}>
              <FaArrowLeft
                style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
            </div>
            <Card className="contactCard2" bordered={false}>
              {loading && (
                <Row style={{ minHeight: "30vh" }} className="flex">
                  <Spin size="large" />
                </Row>
              )}
              {!loading && (
                <Row
                  style={{
                    width: "100%",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >
                  <Col xs={24} md={12}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{
                        fontSize: "20px",
                        fontWeight: 800,
                        color: "black",
                        textAlign: "left",
                        marginTop: 30,
                      }}
                    >
                      Quiz Title
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{
                        fontSize: "16px",
                        color: "grey",
                        textAlign: "center",
                        justifyContent: "center",
                        textAlign: "justify",
                      }}
                    >
                      {quiz?.quiz?.title}
                    </Typography.Text>
                  </Col>

                  <Col xs={24} md={12}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{
                        fontSize: "20px",
                        fontWeight: 800,
                        color: "black",
                        textAlign: "left",
                        marginTop: 30,
                      }}
                    >
                      Course
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{
                        fontSize: "16px",
                        color: "grey",
                        textAlign: "center",
                        justifyContent: "center",
                        textAlign: "justify",
                      }}
                    >
                      {quiz?.quiz?.course?.title || "-"}
                    </Typography.Text>
                  </Col>

                  <Col xs={24} md={12}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{
                        fontSize: "20px",
                        fontWeight: 800,
                        color: "black",
                        textAlign: "left",
                        marginTop: 30,
                      }}
                    >
                      Quiz Date
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{
                        fontSize: "16px",
                        color: "grey",
                        textAlign: "center",
                        justifyContent: "center",
                        textAlign: "justify",
                      }}
                    >
                      {dayjs(quiz?.quiz?.quizDate).format("DD MMMM, YYYY ")}
                    </Typography.Text>
                  </Col>

                  <Col xs={24} md={12}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{
                        fontSize: "20px",
                        fontWeight: 800,
                        color: "black",
                        textAlign: "left",
                        marginTop: 30,
                      }}
                    >
                      Passing Percentage
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{
                        fontSize: "16px",
                        color: "grey",
                        textAlign: "center",
                        justifyContent: "center",
                        textAlign: "justify",
                      }}
                    >
                      {quiz?.quiz?.passingPercentage}
                      {/* {quiz?.quiz?.meetingTime} */}
                    </Typography.Text>
                  </Col>

                  <Col xs={24} md={12}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{
                        fontSize: "20px",
                        fontWeight: 800,
                        color: "black",
                        textAlign: "left",
                        marginTop: 30,
                      }}
                    >
                      Description
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{
                        fontSize: "16px",
                        color: "grey",
                        textAlign: "center",
                        justifyContent: "center",
                        textAlign: "justify",
                      }}
                    >
                      {quiz?.quiz?.description}
                    </Typography.Text>
                  </Col>

                  {quizAttemted && (
                    <Col xs={24} md={12}>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginTop: 30,
                        }}
                      >
                        Score
                      </Typography.Title>
                      <Typography.Text
                        className="fontFamily1"
                        style={{
                          fontSize: "16px",
                          color: "grey",
                          textAlign: "center",
                          justifyContent: "center",
                          textAlign: "justify",
                        }}
                      >
                        {quiz?.quiz?.attempts[0]?.score}
                      </Typography.Text>
                    </Col>
                  )}
                  {quizAttemted && (
                    <Col xs={24} md={12}>
                      <Typography.Title
                        className="fontFamily1"
                        style={{
                          fontSize: "20px",
                          fontWeight: 800,
                          color: "black",
                          textAlign: "left",
                          marginTop: 30,
                        }}
                      >
                        Status
                      </Typography.Title>
                      <Typography.Text
                        className="fontFamily1"
                        style={{
                          fontSize: "16px",
                          color: "grey",
                          textAlign: "center",
                          justifyContent: "center",
                          textAlign: "justify",
                        }}
                      >
                        {quiz?.quiz?.attempts[0]?.status}
                      </Typography.Text>
                    </Col>
                  )}
                </Row>
              )}
              {quizAttemted ? (
                <>
                  <Row justify={"start"} style={{ gap: 10 }} >
                    <Col >
                      <Button
                        type="primary"
                        size="large"
                        block
                        style={{
                          backgroundColor: "#00a79d",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate("/quiz-attempt/" + id)}
                      >
                        View Response
                      </Button>
                    </Col>
                    {quiz?.quiz?.attempts[0]?.status!=="PASSED" &&  <Col>
                      <Button
                        type="primary"
                        size="large"
                        block
                        style={{
                          backgroundColor: "#00a79d",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate("/quiz-attempt/" + id)}
                      >
                        Re Attempt
                      </Button>
                    </Col>}
                  </Row>
                  {/* <Row justify={"start"}>
                  </Row> */}
                </>
              ) : (
                <Row justify={"start"}>
                  <Col>
                    <Button
                      type="primary"
                      size="large"
                      block
                      style={{ backgroundColor: "#00a79d", cursor: "pointer" }}
                      onClick={() => navigate("/quiz-attempt/" + id)}
                    >
                      Attempt Quiz
                    </Button>
                  </Col>
                </Row>
              )}
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default QuizDetails;
